/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Workout_Live_Implausible_FixInputs */

const en_us2_workout_live_implausible_fix = /** @type {(inputs: Workout_Live_Implausible_FixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fix it`)
};

const pt_br2_workout_live_implausible_fix = /** @type {(inputs: Workout_Live_Implausible_FixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrigir`)
};

const es_419_workout_live_implausible_fix = /** @type {(inputs: Workout_Live_Implausible_FixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corregir`)
};

const pt_pt2_workout_live_implausible_fix = /** @type {(inputs: Workout_Live_Implausible_FixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corrigir`)
};

const fr_fr2_workout_live_implausible_fix = /** @type {(inputs: Workout_Live_Implausible_FixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Corriger`)
};

const de_de2_workout_live_implausible_fix = /** @type {(inputs: Workout_Live_Implausible_FixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Korrigieren`)
};

const it_it2_workout_live_implausible_fix = /** @type {(inputs: Workout_Live_Implausible_FixInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Correggi`)
};

/**
* | output |
* | --- |
* | "Fix it" |
*
* @param {Workout_Live_Implausible_FixInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const workout_live_implausible_fix = /** @type {((inputs?: Workout_Live_Implausible_FixInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Workout_Live_Implausible_FixInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_workout_live_implausible_fix(inputs)
	if (locale === "es-419") return es_419_workout_live_implausible_fix(inputs)
	if (locale === "pt-PT") return pt_pt2_workout_live_implausible_fix(inputs)
	if (locale === "fr-FR") return fr_fr2_workout_live_implausible_fix(inputs)
	if (locale === "de-DE") return de_de2_workout_live_implausible_fix(inputs)
	if (locale === "it-IT") return it_it2_workout_live_implausible_fix(inputs)
	return en_us2_workout_live_implausible_fix(inputs)
});
export { workout_live_implausible_fix as "workout-live.implausible_fix" }